/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { footerProvisionalDetailConfig } from '../../config/footer.config';

export interface IFooterPluginMethods extends IPluginMethodMap {
  getFooterSync(args?: any): any;
}

export class FooterPlugin implements IAgentPlugin {
  readonly methods: IFooterPluginMethods;

  constructor() {
    this.methods = {
      getFooterSync: this.getFooterSync.bind(this),
    };
  }

  getFooterSync(args?: any) {
    return {
      footer: footerProvisionalDetailConfig,
    };
  }
}
